import { ShootBuilder } from "../scene-control/shoot-builder";

export const shootBuilder = ShootBuilder.init().setNamer(
  (pos: string) => `comic-${pos}`
);
